<template>
<div id="id01" class="modal">
  <div class="centeredDiv">
  <div style="height: 30px; position: relative; margin: auto; max-width: 800px">
  <div id="alertError" class="alertError">
    <h4 id="msgAlert" class="alertMessage">
      {{this.loggedIn}}
    </h4>
  </div>
  </div>
  <form class="modal-content animate" @submit.prevent="loginRequest">
    <div class="container">
      <label for="email"><b>Usuário</b></label>
      <input
        type="email"
        placeholder="E-mail"
        name="email"
        v-model="loginEmail"
        required>

      <label for="password"><b>Senha</b></label>
      <input
        type="password"
        placeholder="Senha"
        name="password"
        v-model="loginPassword"
        required>

      <div class="divButtons">
        <button type="submit">Login</button>
        <button type="button" onclick="document.getElementById('id01').style.display='none'"
          class="cancelbtn">Cancelar</button>
      </div>
    </div>
  </form>
  </div>
</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  props: ['manageVisible'],
  data() {
    return {
      loginEmail: null,
      loginPassword: null,
      msgError: null,
    };
  },
  watch: {
    manageVisible: {
      immediate: true,
      deep: true,
      handler(newVelue) {
        if (newVelue > 0) {
          document.getElementById('id01').style.display = 'block';
          document.getElementsByName('email')[0].focus();
        }
      },
    },
    loggedIn: {
      immediate: true,
      deep: true,
      handler(newVelue) {
        if (newVelue) {
          this.fetchProperties();
          if (!document.getElementById('id01')) return true;
          document.getElementById('id01').style.display = 'none';
        }
      },
    },
    loginError: {
      immediate: true,
      deep: true,
      handler(newVelue) {
        if (newVelue) {
          const msgAlert = document.getElementById('alertError');
          msgAlert.style.display = 'flex';
          this.msgError = newVelue;
          const newAlert = msgAlert.cloneNode(true);
          msgAlert.parentNode.replaceChild(newAlert, msgAlert);
          document.getElementById('msgAlert').innerText = newVelue;
        }
      },
    },
  },
  computed: {
    ...mapState('authentication', [
      'loginError',
      'loggedIn',
    ]),
  },
  methods: {
    ...mapActions('authentication', [
      'login',
    ]),
    ...mapActions('properties', [
      'fetchProperties',
    ]),
    ...mapMutations('authentication', [
      'setLoginEmail',
      'setLoginPassword',
    ]),
    loginRequest(e) {
      e.submitted = true;
      this.setLoginEmail(this.loginEmail);
      this.setLoginPassword(this.loginPassword);
      this.login();
    },
  },
};
</script>

<style>
input[type=email], input[type=password] {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  box-sizing: border-box;
}

button {
  background-color: #4CAF50;
  color: white;
  padding: 10px 18px;
  margin: 8px;
  border: none;
  cursor: pointer;
  width: 100px;
}

button:hover {
  opacity: 0.8;
}

.cancelbtn {
  width: 100px;
  padding: 10px 18px;
  margin-left: 16px;
  background-color: #f44336;
}

.container {
  padding: 16px;
}

span.psw {
  float: right;
  padding-top: 16px;
}

/* The Modal (background) */
.modal {
  display: none;
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.alertError {
  position: absolute;
  display: none;
  width: 100%;
  max-width: 800px;
  background-color: red;
  margin: auto;
  bottom: 0%;
  border-radius: 5px;
  animation:
    alertError 0.5s cubic-bezier(.11,.94,.83,.67) 0s 1 normal,
    alertError 4.5s step-start 0.5s 1 normal,
    alertError 2s cubic-bezier(0,1.36,.94,.79) 5s 1 reverse forwards;
}
@keyframes alertError {
  from {display: none; height: 0;}
  to {height: 30px;}
}
.alertMessage {
  position: relative;
  margin: auto;
  align-items: center;
  animation:
    alertMessage 0.5s cubic-bezier(.11,.94,.83,.67) 0s 1 normal,
    alertMessage 4.5s step-start 0.5s 1 normal,
    alertMessage 2s cubic-bezier(0,1.36,.94,.79) 5s 1 reverse forwards;
}
@keyframes alertMessage {
  from {font-size: 0px;}
  to {font-size: 20px;}
}
.modal-content {
  background-color: #fefefe;
  /* margin: 5% auto 15% auto; */
  border: 1px solid #888;
  width: 100%; /* Could be more or less, depending on screen size */
  max-width: 800px;
  margin: auto;
}
.centeredDiv {
  position: absolute;
  width: 80%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* The Close Button (x) */
.close {
  position: absolute;
  right: 25px;
  top: 0;
  color: #000;
  font-size: 35px;
  font-weight: bold;
}
.divButtons {
  display: inline;
}

.close:hover,
.close:focus {
  color: red;
  cursor: pointer;
}

/* Add Zoom Animation */
.animate {
  -webkit-animation: animatezoom 0.6s;
  animation: animatezoom 0.6s;
}

@-webkit-keyframes animatezoom {
  from {-webkit-transform: scale(0)}
  to {-webkit-transform: scale(1)}
}

@keyframes animatezoom {
  from {transform: scale(0)}
  to {transform: scale(1)}
}
</style>
